import { render } from "./SolutionsSlick.vue?vue&type=template&id=4d19b4c5"
import script from "./SolutionsSlick.vue?vue&type=script&lang=js"
export * from "./SolutionsSlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/SolutionsSlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d19b4c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d19b4c5', __exports__)) {
    api.reload('4d19b4c5', __exports__)
  }
  
  module.hot.accept("./SolutionsSlick.vue?vue&type=template&id=4d19b4c5", () => {
    api.rerender('4d19b4c5', render)
  })

}


export default __exports__